import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const ProfileField = ({ label, children }) => (_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("div", Object.assign({ className: "col-md-3" }, { children: _jsx("label", { children: label }) })), _jsx("div", Object.assign({ className: "col-md-6" }, { children: children }))] })));
export default ProfileField;
